<template>
  <div
    v-if="appList.length"
    class="app-choice-resume"
  >
    <div class="d-flex justify-center justify-md-start">
      <span
        v-for="(app, index) in appList"
        :key="index"
        class="apps-resume-icon"
      >
        <v-img
          v-if="app.iconUrl"
          :src="app.iconUrl"
          width="24"
        />
        <v-icon
          v-else
          class="default-icon"
        >
          mdi-application
        </v-icon>
      </span>
      <span
        class="services-resume-selected"
      >
        <span class="apps-resume">
          {{ appList.length }}

          <slot
            v-if="appList.length===1"
            name="caption-singular"
          />
          <slot
            v-else
            name="caption-plural"
          />
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLibraryChoiceResume',
  props: {
    appList: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
.app-choice-resume {
  .apps-resume-icon {
    float: left;
    margin-right: -7px;
    border: 1px solid lightgray;
    overflow: hidden;
    position: relative;
    border-radius: 10px;
  }
}
</style>